import { isNull } from 'utils/validation';

export default value => (isNull(value) ? null : value === false);
